// @flow
import * as React from 'react';
// eslint-disable-next-line import/named
import { type IntlShape } from 'react-intl';

// Components
import Button from 'components/atoms/Button';
import Modal from 'components/atoms/Modal';
import ParseHTML from 'components/atoms/ParseHTML';
import TermsPrivacyLoader from 'components/pages/components/ContentFooter/components/TermsPrivacy/TermsPrivacyLoader.js';
import LoaderHOC from 'components/atoms/LoaderHOC';

// Utils
import { isUrl, truncateText } from 'utils/string';

import './Disclaimer.scss';

const ns = 'disclaimer-component';

export type Props = {
  disclaimerInfo: Object,
  intl: IntlShape,
  dealerName: string
};

class Disclaimer extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    (this: any).disclaimerModal = React.createRef();
  }

  disclaimerModal: React.Ref<any>;

  getMoreButton = (disclaimer: string = '') => {
    const { intl, disclaimerInfo } = this.props;
    return (
      <span>
        <Button
          buttonTheme="link"
          className={`${ns}__button`}
          onClick={() => {
            if (isUrl(disclaimer)) {
              window.open(disclaimer);
            } else {
              (this: any).disclaimerModal.current.setShowModal(true);
            }
          }}
          id={`${ns}_button`}
        >
          {intl.formatMessage(disclaimerInfo.seeMoreButtonText)}
        </Button>
        <Modal
          ref={this.disclaimerModal}
          title={() => (
            <div>{intl.formatMessage(disclaimerInfo.modalTitle)}</div>
          )}
        >
          <LoaderHOC
            serviceId={'data'}
            placeHolderType={() => <TermsPrivacyLoader />}
            component={() => <ParseHTML html={disclaimer} />}
          />
        </Modal>
      </span>
    );
  };

  render() {
    const { intl, disclaimerInfo, dealerName } = this.props;
    const disclaimer = intl.formatMessage(disclaimerInfo.disclaimerText, {
      dealerName
    });
    const textLimit = 480;
    const text = truncateText(disclaimer, textLimit);
    const disclaimerStr = intl.formatMessage(disclaimerInfo.disclaimerTitle);
    const regEx = new RegExp(disclaimerStr, 'i');
    const title = `${disclaimerStr} `;
    text['formattedText'] = text['formattedText'].replace(regEx, '');

    return (
      <div className={`${ns}__disclaimer`}>
        <span className={`${ns}__disclaimer--text`}>{title}</span>
        {isUrl(disclaimer) ? (
          this.getMoreButton(text['originalText'])
        ) : (
          <span>
            <ParseHTML
              className={`${ns}__disclaimer--html`}
              html={text['formattedText']}
              aria-disabled={true}
            />
            {text['isTruncated'] && this.getMoreButton(text['originalText'])}
          </span>
        )}
      </div>
    );
  }
}

export default Disclaimer;



// WEBPACK FOOTER //
// ./src/components/atoms/Disclaimer/Disclaimer.js